module.exports = __webpack_public_path__ + "img/makehuman.03a34cda.png";